import KnockOut from "knockout";
import KnockOutMapping from "knockout-mapping";
import BookingRegistrationPage from "../Pages/BookingRegistrationPage";

export default class BookingRegistrationViewModel {
    constructor() {
        let self: any = this;

        self.eventIdMaster = String((<any>window).App.bag.eventIdMaster);
        self.demoProductSelected = KnockOut.observable();
        self.slotDateSelected = KnockOut.observable();
        self.isDemoProductSelected = KnockOut.observable(false);
        self.selectedDemoProduct = KnockOut.observable();
        self.isUnderage = KnockOut.observable(false);
        self.isItalianAddress = KnockOut.observable(false);
        self.isParentItalianAddress = KnockOut.observable(false);
        self.isParent2ItalianAddress = KnockOut.observable(false);

        self.eventSlotDates = KnockOut.observableArray();
        self.eventSlots = KnockOut.observableArray();
        self.isDateSelected = KnockOut.observable(false);

        self.countries = KnockOut.observableArray();
        self.regions = KnockOut.observableArray();
        self.provinces = KnockOut.observableArray();

        self.parentCountries = KnockOut.observableArray();
        self.parentRegions = KnockOut.observableArray();
        self.parentProvinces = KnockOut.observableArray();

        self.parent2Countries = KnockOut.observableArray();
        self.parent2Regions = KnockOut.observableArray();
        self.parent2Provinces = KnockOut.observableArray();

        self.demoProductSelected.subscribe(function (data) {
            if (data) {
                self.selectedDemoProduct(data);

                (<any>window).App.instances.vm.$store.dispatch("testRideStore/getBookingEventSlotTable", {
                    demoProductFrame: data,
                    eventIdMaster: self.eventIdMaster
                }).then((response) => {
                    self.isDemoProductSelected(true);
                    var eventSlotDates = KnockOutMapping.fromJS(response.data);
                    self.eventSlotDates(eventSlotDates());
                    $("#EventSlotId").val("");
                    self.isDateSelected(false);
                });
            } else {
                self.isDemoProductSelected(false);
                self.selectedDemoProduct(null);
                self.isDateSelected(false);
            }
        });

        self.onChangeEventSlotDate = function (data) {
            if (data) {
                (<any>window).App.instances.vm.$store.dispatch("testRideStore/getBookingEventSlotsTime", {
                    demoProductFrame: self.selectedDemoProduct(),
                    eventIdMaster: self.eventIdMaster,
                    slotDate: data()
                }).then((response) => {
                    var eventSlots = KnockOutMapping.fromJS(response.data);
                    self.eventSlots(eventSlots());
                    $("#EventSlotId").val("");

                    self.isDateSelected(true);
                });
            } else {
                self.eventSlots([]);
                self.isDateSelected(false);
            }
        };

        self.onChangeCountry = function (data) {
            if (data === "Italy") {
                self.isItalianAddress(true);
                getRegions();
            } else {
                self.isItalianAddress(false);
            }
        };

        self.onChangeRegion = function (data) {
            if (data) {
                getProvinces(data);
                $("#Location").val("");
                $("#PostCode").val("");
            }
        };

        self.onChangeProvince = function () {
            $("#Location").val("");
            $("#PostCode").val("");
        };

        self.onChangeParentCountry = function (data) {
            if (data === "Italy") {
                self.isParentItalianAddress(true);
                getParentRegions();
            } else {
                self.isParentItalianAddress(false);
            }
        };

        self.onChangeParentRegion = function (data) {
            if (data) {
                getParentProvinces(data);
                $("#ParentLocation").val("");
                $("#ParentPostCode").val("");
            }
        };

        self.onChangeParentProvince = function () {
            $("#ParentLocation").val("");
            $("#ParentPostCode").val("");
        };

        self.onChangeParent2Country = function (data) {
            if (data === "Italy") {
                self.isParent2ItalianAddress(true);
                getParent2Regions();
            } else {
                self.isParent2ItalianAddress(false);
            }
        };

        self.onChangeParent2Region = function (data) {
            if (data) {
                getParent2Provinces(data);
                $("#Parent2Location").val("");
                $("#Parent2PostCode").val("");
            }
        };

        self.onChangeParent2Province = function () {
            $("#Parent2Location").val("");
            $("#Parent2PostCode").val("");
        };

        self.onChangeBirthDate = function (data) {
            if (data) {
                var today = new Date();
                var birthDate = new Date(data);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();

                if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
                    age--;
                }

                if (age < 18) {
                    self.isUnderage(true);
                    getParentCountries();
                    $("#ParentBirthCountry").val("ITALIA");
                    $("#ParentAddressType").val("Via");

                    BookingRegistrationPage.setParentPersonalDataBox();

                    getParent2Countries();
                    $("#Parent2BirthCountry").val("ITALIA");
                    $("#Parent2AddressType").val("Via");

                    BookingRegistrationPage.setParent2PersonalDataBox();
                } else {
                    self.isUnderage(false);
                }
            }
        };

        function getCountries() {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getCountries").then((response) => {
                if (response.data) {
                    var countries = KnockOutMapping.fromJS(response.data);
                    self.countries(countries());
                    $("#Country").val("Italy");
                    self.isItalianAddress(true);
                    getRegions();
                }
            });
        }

        function getRegions() {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getRegions").then((response) => {
                if (response.data) {
                    var regions = KnockOutMapping.fromJS(response.data);
                    self.regions(regions());
                }
            });
        }

        function getProvinces(region) {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getProvinces", { region: region }).then((response) => {
                if (response.data) {
                    var provinces = KnockOutMapping.fromJS(response.data);
                    self.provinces(provinces());
                }
            });
        }

        function getParentCountries() {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getCountries").then((response) => {
                if (response.data) {
                    var countries = KnockOutMapping.fromJS(response.data);
                    self.parentCountries(countries());
                    $("#ParentCountry").val("Italy");
                    self.isParentItalianAddress(true);
                    getParentRegions();
                }
            });
        }

        function getParentRegions() {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getRegions").then((response) => {
                if (response.data) {
                    var regions = KnockOutMapping.fromJS(response.data);
                    self.parentRegions(regions());
                }
            });
        }

        function getParentProvinces(region) {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getProvinces", { region: region }).then((response) => {
                if (response.data) {
                    var provinces = KnockOutMapping.fromJS(response.data);
                    self.parentProvinces(provinces());
                }
            });
        }

        function getParent2Countries() {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getCountries").then((response) => {
                if (response.data) {
                    var countries = KnockOutMapping.fromJS(response.data);
                    self.parent2Countries(countries());
                    $("#Parent2Country").val("Italy");
                    self.isParent2ItalianAddress(true);
                    getParent2Regions();
                }
            });
        }

        function getParent2Regions() {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getRegions").then((response) => {
                if (response.data) {
                    var regions = KnockOutMapping.fromJS(response.data);
                    self.parent2Regions(regions());
                }
            });
        }

        function getParent2Provinces(region) {
            (<any>window).App.instances.vm.$store.dispatch("profileStore/getProvinces", { region: region }).then((response) => {
                if (response.data) {
                    var provinces = KnockOutMapping.fromJS(response.data);
                    self.parent2Provinces(provinces());
                }
            });
        }

        function init() {
            getCountries();
            $("#BirthCountry").val("ITALIA");
            $("#AddressType").val("Via");
        }

        init();
    }
}